<template>

    <div id="contents"><div id="contents-inner"><div id="screen1main-contents">
        <div class="regist">
            <vue-headful title="会員申込画面" />
            <!-- 会員申込の場合 -->
            <div class="section page-mypage mb32" v-if="registInit.pageMode == 0">
                <!--画面タイトル(ページタイトル)-->
                <div class="section-inner" style="border:none">
                    <span class="h1 font-weight-bold" v-html="registInit.descriptionInfo['48']"></span>
                </div>
                <!--登録項目-->
                <div class="section-inner">
                        <!--エラーメッセージ表示-->
                        <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="REGIST_PART"/>
                                <div v-if="listReport.length > 0">
                        <!-- listReport -->
                        <ul role="alert">
                            <li class="text-danger" v-for="report in listReport" :key="report">
                                <span class="font-weight-bold">{{report}}</span>
                            </li>
                        </ul>
                    </div>
                    <!-- 説明(画面上部メッセージ)-->
                    <div v-html="registInit.descriptionInfo['47']"></div>
                    <div style="display:none;">
                        <span id="mail_confirm_lbl">{{$t('regist.labels.subMailAddress')}}</span>
                        <span id="passwordSub_lbl">{{$t('regist.labels.subPassword')}}</span>
                    </div>
                    <!--登録項目-->
                    <table class="personal mb32">
                        <!--ポイントカード番号 -->
                        <tr>
                            <th  id="tel1_lbl">{{$t('regist.labels.pointCardNo')}}</th>
                            <td>
                                <!--項目説明マスタ[23]-->
                                <div v-html="registInit.descriptionInfo['4']"></div>
                                <div v-html="registRequest.pointCardNo.substr(6, 6)"></div>
                                <!--項目説明マスタ[24]-->
                                <div v-html="registInit.descriptionInfo['5']"></div>
                            </td>
                        </tr>
                        <!--名前-->
                        <tr>
                            <th :class="'required'">{{$t('regist.labels.names')}}</th>
                            <td>
                                <!--項目説明マスタ[11]-->
                                <div v-html="registInit.descriptionInfo['11']"></div>
                                <div class="form-column">
                                    <!--姓-->
                                    <template v-if="registInit.name2Flg == 1">
                                        <label for="nm" class="num02">{{$t('regist.labels.surname')}}</label>
                                    </template>
                                    <template v-else>
                                        <label for="nm1" class="num02">{{$t('regist.labels.name1')}}</label>
                                    </template>
                                    <span id="nm_lbl" hidden>{{$t('regist.labels.name1')}}</span>
                                    <span id="nm1_lbl" hidden>{{$t('regist.labels.nameSurname')}}</span>
                                    <template v-if="registInit.name2Flg == 1">
                                        <input-check 
                                                    type="text" name="nm1" id="nm1" size="30" @on-input-change="change()"
                                                    class="form-control-sm" maxlength="50" 
                                                    v-model="registRequest.nm1" style=""/>
                                    </template>
                                    <template v-else>
                                        <input-check 
                                                    type="text" name="nm" id="nm" size="30" @on-input-change="change()"
                                                    class="form-control-sm w-100" maxlength="50" 
                                                    v-model="registRequest.nm1" style="max-width:85%"/>
                                    </template>
                                    <!--名 -->
                                    <template v-if="registInit.name2Flg == 1">
                                        <label for="nm2" class="num02">{{$t('regist.labels.name2')}}</label>
                                        <span id="nm2_lbl" hidden>{{$t('regist.labels.nameFirstName')}}</span>
                                        <input-check type="text" name="nm2" id="nm2" class="form-control-sm"
                                                    @on-input-change="change()" size="30" maxlength="50" v-model="registRequest.nm2" />
                                    </template>
                                </div>
                                <!--項目説明マスタ[12]-->
                                <div v-html="registInit.descriptionInfo['12']"></div>
                            </td>
                        </tr>
                        <!--カナ-->
                        <tr>
                            <!--カナ必須オプション-->
                            <th :class="'required'">{{$t('regist.labels.phoneTic')}}</th>
                            <td>
                                <!--項目説明マスタ[13]-->
                                <div v-html="registInit.descriptionInfo['13']"></div>
                                <div class="form-column">
                                    <!--姓-->
                                    <template v-if="registInit.name2Flg == 1">
                                        <label for="kana1" class="num02">{{$t('regist.labels.surname')}}</label>
                                    </template>
                                    <template v-else>
                                        <label for="kana" class="num02">{{$t('regist.labels.name1')}}</label>
                                    </template>
                                    <span id="kana_lbl" hidden>{{$t('regist.labels.nameKana1')}}</span>
                                    <span id="kana1_lbl" hidden>{{$t('regist.labels.nameSurnameKana')}}</span>
                                    <template v-if="registInit.name2Flg == 1">
                                        <input-check 
                                                    type="text" name="kana1" size="30" @on-input-change="change()"
                                                    class="form-control-sm" id="kana1" maxlength="50" 
                                                    v-model="registRequest.kana1" />
                                    </template>
                                    <template v-else>
                                        <input-check 
                                                    type="text" name="kana" size="30" @on-input-change="change()"
                                                    class="form-control-sm w-100" id="kana" maxlength="50" 
                                                    v-model="registRequest.kana1" style="max-width:85%"/>
                                    </template>
                                    <!--名-->
                                    <template v-if="registInit.name2Flg == 1">
                                    <label for="kana2" class="num02">{{$t('regist.labels.name2')}}</label>
                                    <span id="kana2_lbl" hidden>{{$t('regist.labels.nameSurFirstNameKana')}}</span>
                                    <input-check type="text" name="kana2" size="30" class="form-control-sm"
                                                @on-input-change="change()" id="kana2" maxlength="50" v-model="registRequest.kana2" />
                                    </template>
                                </div>
                                <!--項目説明マスタ[14]-->
                                <div v-html="registInit.descriptionInfo['14']"></div>
                            </td>
                        </tr>
                        <!--性別 -->
                        <tr >
                            <th :class="'required'">
                                {{$t('common.labels.sex')}}
                            </th>
                            <!--性別更新オプション-->
                            <td>
                                <!--項目説明マスタ[29]-->
                                <div v-html="registInit.descriptionInfo['29']"></div>
                                <input type="radio" class="radioAlign" name="sexKbn"  value="1" v-model="registRequest.sexKbn" id="sexKbn_0">
                                <label for="sexKbn_0">&nbsp;{{$t('common.labels.male')}}&nbsp;</label>
                                <input type="radio" class="radioAlign" name="sexKbn"  value="2" v-model="registRequest.sexKbn" id="sexKbn_1">
                                <label for="sexKbn_1">&nbsp;{{$t('common.labels.female')}}&nbsp;</label>
                                <input type="radio" class="radioAlign" name="sexKbn"  value="9" v-model="registRequest.sexKbn" id="sexKbn_2">
                                <label for="sexKbn_2">&nbsp;{{$t('common.labels.unspecified')}}&nbsp;</label>
                                &nbsp;
                                <!--項目説明マスタ[30]-->
                                <div v-html="registInit.descriptionInfo['30']"></div>
                            </td>
                        </tr>
                        <!--郵便番号 -->
                        <tr>
                            <th class="required" id="zip_lbl">{{$t('common.labels.postalCode')}}</th>
                            <td ontouchstart="">
                                <!--項目説明マスタ[15]-->
                                <div v-html="registInit.descriptionInfo['15']"></div>
                                <div class="form-row">
                                    <input-check type="text" class="zip form-control-sm" @on-input-change="change()"
                                                name="zip" size="30" id="zip" maxlength="8" v-model="registRequest.zip" style="max-width:150px"/>
                                    <span class="btn_addsearch btn_addsearch_regist" style="">
                                        <a @click="addrAutoInput('kokyaku')">{{$t('common.labels.addressSearch')}}</a>
                                    </span>
                                </div>
                                <!--項目説明マスタ[16]-->
                                <div v-html="registInit.descriptionInfo['16']"></div>
                            </td>
                        </tr>
                        <!--住所1（市区町村） -->
                        <tr>
                            <th class="required" id="addr1_lbl">{{$t('regist.labels.city')}}</th>
                            <td>
                                <!--項目説明マスタ[17]-->
                                <div v-html="registInit.descriptionInfo['17']"></div>
                                <input-check type="text" class="form-control-sm w-100"
                                            @on-input-change="change()" name="addr1" size="50" id="addr1" maxlength="100" v-model="registRequest.addr1" />
                                
                                <!--項目説明マスタ[18]-->
                                <div v-html="registInit.descriptionInfo['18']"></div>
                            </td>
                        </tr>
                        <!--住所2（番地以下）-->
                        <tr>
                            <th class="required" id="addr2_lbl">{{$t('regist.labels.lessAddress')}}</th>
                            <td>
                                <!--項目説明マスタ[19]-->
                                <div v-html="registInit.descriptionInfo['19']"></div>
                                <input-check type="text" id="addr2" name="addr2" size="50"
                                            class="form-control-sm w-100" @on-input-change="change()" maxlength="100" v-model="registRequest.addr2" />
                               
                                <!--項目説明マスタ[20]-->
                                <div v-html="registInit.descriptionInfo['20']"></div>
                            </td>
                        </tr>
                        <!--住所3（建物名・会社名）-->
                        <tr>
                            <th class="optional" id="addr3_lbl">{{$t('regist.labels.optionLabel')}}</th>
                            <td>
                                <!--項目説明マスタ[21]-->
                                <div v-html="registInit.descriptionInfo['21']"></div>
                                <input-check type="text" id="addr3" name="addr3"
                                            size="35" class="form-control-sm w-100" maxlength="100" v-model="registRequest.addr3" />
                               
                                <!--項目説明マスタ[22]-->
                                <div v-html="registInit.descriptionInfo['22']"></div>
                            </td>
                        </tr>
                        <!--電話番号 -->
                        <tr>
                            <th class="required" id="tel1_lbl">{{$t('regist.labels.phoneNumber')}}</th>
                            <td>
                                <!--項目説明マスタ[23]-->
                                <div v-html="registInit.descriptionInfo['23']"></div>
                                <input-check type="text" id="tel1" name="tel1" class="code form-change form-control-sm"
                                            @on-input-change="change()" size="18" maxlength="15" v-model="registRequest.tel1" />
                                <!--項目説明マスタ[24]-->
                                <div v-html="registInit.descriptionInfo['24']"></div>
                            </td>
                        </tr>
                        <!-- 生年月日-->
                        <tr>
                            <th class="required">
                                <span id="birthDay_lbl">{{$t('common.labels.birthday')}}</span>
                            </th>
                            <!--生年月日更新オプション-->
                            <td>
                                <!--項目説明マスタ[27]-->
                                <div v-html="registInit.descriptionInfo['27']"></div>
                                <span id="birthDayYYYY_lbl" hidden>{{$t('regist.labels.birthDayYYYY')}}</span>
                                <span id="birthDayMM_lbl" hidden>{{$t('regist.labels.birthDayMM')}}</span>
                                <span id="birthDayDD_lbl" hidden>{{$t('regist.labels.birthDayDD')}}</span>

                                <input-check type="text" id="birthDayYYYY" class="numcode form-change form-control-sm mb-2" style="max-width:50%"
                                            @on-input-change="change()" name="birthDay_YYYY" maxlength="4" size="7" v-model="registRequest.birthDayYYYY" />
                                {{$t('common.labels.year')}}&nbsp;
                                <select v-model="registRequest.birthDayMM" id="birthDayMM" name="birthDay_MM" class="form-control-sm mb-2" @change="change()" style="max-width:50%">
                                    <option></option>
                                    <template v-for="mm in 12" >
                                        <option v-if="mm < 10" :key="mm" :value="'0'+mm">{{'0'+mm}}</option>
                                        <option v-else :key="mm" :value="mm">{{mm}}</option>
                                    </template>
                                </select>&nbsp;{{$t('common.labels.month')}}&nbsp;
                                <select v-model="registRequest.birthDayDD" id="birthDayDD"  name="birthDay_DD" class="form-control-sm mb-2" @change="change()"  style="max-width:50%">
                                    <option></option>
                                    <template v-for="dd in 31" >
                                        <option v-if="dd < 10" :key="dd" :value="'0'+dd">{{'0'+dd}}</option>
                                        <option v-else :key="dd" :value="dd">{{dd}}</option>
                                    </template>
                                </select>&nbsp;{{$t('common.labels.day')}}&nbsp;
                                <!--項目説明マスタ[28]-->
                                <div v-html="registInit.descriptionInfo['28']"></div>
                            </td>
                        </tr>
                        <!--ご来店のきっかけ -->
                        <tr>
                            <th class="required">
                                <span id="fax_lbl">{{$t('regist.labels.comeReason')}}</span>
                                <span id="comeReason1_lbl" hidden>{{$t('regist.labels.comeReasonMessage')}}</span>
                            </th>
                            <td>
                                <template v-for="(item, index) in registInit.comeReasonList" >
                                    <div :key="index" class="">
                                        <input v-model="registRequest.comeReason" type="radio" :name="'comeReason'+index" 
                                        :id="'comeReason'+index" :value="item.KEY" false="" class="m-2">
                                        <label :title="item.VALUE" style="position: relative;"  :for="'comeReason'+index">{{item.VALUE}}</label>
                                    </div>
                                </template>
                            </td>
                        </tr>
                        <!-- メールアドレス-->
                        <tr>
                            <th class="optional" >
                                <span id="mail_lbl">{{$t('common.labels.mailAddress')}}</span>
                            </th>
                            <td>
                                <!--項目説明マスタ[1]-->
                                <div v-html="registInit.descriptionInfo['1']"></div>
                                <input-check type="text" class="mail form-change mode form-control-sm"
                                            id="mail" name="mail" maxlength="100" size="35" v-model="registRequest.mail" />
                                <!--項目説明マスタ[2]-->
                                <div v-html="registInit.descriptionInfo['2']"></div>
                            </td>
                        </tr>
                        <!-- 新商品やお得な情報をおハガキにてお届け-->
                        <tr>
                            <th class="optional">
                            {{$t('regist.labels.emailMagazine')}}
                            </th>
                            <td>
                                <ul class="radio-column">
                                <!--項目説明マスタ[31]-->
                                <div v-html="registInit.descriptionInfo['31']"></div>
                                <li><input type="radio" name="dmFlg" value="0" v-model="registRequest.dmFlg" id="dmFlg_1"><label for="dmFlg_1">
                                {{$t('regist.labels.doNotWant')}}&nbsp;</label></li>
                                <li><input type="radio" name="dmFlg" value="1" v-model="registRequest.dmFlg" id="dmFlg_0"><label for="dmFlg_0">
                                {{$t('regist.labels.toWish')}}&nbsp;</label></li>
                                &nbsp;
                                <!--項目説明マスタ[32]-->
                                <div v-html="registInit.descriptionInfo['32']"></div>
                                </ul>
                            </td>
                        </tr>
                    </table>
                    <br>
                    <!--会員規約-->
                    <table class="agreement" style="table-layout:fixed">
                        <tr>
                            <td class="border_1 pl05" bgcolor="#e3e3e3" width="100%">{{$t('regist.labels.membership')}}</td>
                        </tr>
                        <tr>
                            <td colspan="2" align="center" width="100%">
                                <!--会員規約内容-->
                                <div class="agreement_desc" v-html="registInit.descriptionInfo['40']"></div>
                            </td>
                        </tr>
                        <tr>
                            <td align="center">
                                <!-- 規約に同意する -->
                                <input type="radio" id="AgreeFlag1" name="AgreeFlag" value="1" v-model="registRequest.agreeFlag" :readonly="isConfirm" :disabled="isConfirm">
                                <label for="AgreeFlag1">{{$t('regist.labels.agreeItems')}}</label>
                                &nbsp;&nbsp;
                                <!-- 規約に同意しない -->
                                <input type="radio" id="AgreeFlag0" name="AgreeFlag" value="0" v-model="registRequest.agreeFlag" :readonly="isConfirm" :disabled="isConfirm">
                                <label for="AgreeFlag0">{{$t('regist.labels.dontAgree')}}</label>
                            </td>
                        </tr>
                    </table>
                
                    <!-- 説明(画面下部メッセージ)-->
                    <div v-html="registInit.descriptionInfo['46']"></div>
                    <!--登録ボタン-->
                    <div id="btn_roll2">
                        <a class="submit-button" id="submitButton" @click="confirmDoInsert()">{{$t('common.buttons.signup')}}</a>
                    </div>
                </div>
                <!-- modal confirm area -->
                <!--アラート表示-->
                <alert-confirm
                    v-if="isModalShow"
                    :msgConfirm="msgConfirm"
                    :okAction="doAction"
                    :isButtonCancel="isButtonCancel">
                </alert-confirm>
            </div>
            <!-- すでに登録しました場合-->
            <div class="section page-mypage mb32" v-else-if="registInit.pageMode == 2">
                <!--画面タイトル(ページタイトル)-->
                <div class="section-inner" style="border:none">
                    <span class="h1 font-weight-bold" v-html="registInit.descriptionInfo['48']"></span>
                </div>
                <div v-html="registInit.descriptionInfo['49']"></div>
            </div>
            <!-- 入力したURLが不正の場合-->
            <div class="section page-mypage mb32" v-else-if="registInit.pageMode == 1">
                <!--画面タイトル(ページタイトル)-->
                <div class="section-inner" style="border:none">
                    <span class="h1 font-weight-bold" v-html="registInit.descriptionInfo['48']"></span>
                </div>
                <div v-html="registInit.descriptionInfo['50']"></div>
            </div>
            <!-- 入力したURLが不正の場合-->
            <div class="section page-mypage mb32" v-else-if="registInit.pageMode == 3">
                <!--画面タイトル(ページタイトル)-->
                <div class="section-inner" style="border:none">
                    <span class="h1 font-weight-bold" v-html="registInit.descriptionInfo['48']"></span>
                </div>
                <div v-html="registInit.descriptionInfo['51']"></div>
            </div>
        </div>
    </div></div></div>
 
</template>

<script>
/*
* Import libs and componnents
*/
import axios from "assets/js/request";
import common from 'assets/js/common';
import EventBus from 'assets/js/eventBus';
import Message from 'components/MessageEcSite';
import Loading from 'vue-loading-overlay';
import InputCheck from 'components/InputCheck.vue';
import AlertConfirm from 'components/AlertConfirm';
import SiteConstants from 'assets/const/SiteConstants.json';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import toastr from 'toastr/toastr.js';
import "toastr/build/toastr.min.css";

toastr.options = {
  closeButton: true,
  positionClass: "toast-top-right",
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "3000",
};

export default {
    /*
    * Name of component
    */
    name: "Regist",
    /*
    * Declare components
    */
    components: {
        Message: Message,
        Loading,
        InputCheck,
        AlertConfirm,
        Breadcrumb,
        toastr
    },
    /*
    * Declare variable and set default value
    */
    data: function() {
        return {
            REGIST_PART: 'regist',
            isLoading: false,
            isDisplay: false,
            registInit: {
                orderInfo:{},
                realAuthoriFlg: 1,
                descriptionInfo:{},
                backButtonFlg: 0,
                name2Flg : 1
            },
            registRequest: {
                agreeFlag:0,
                zip:null,
                zip1:null,
                zip2:null,
                addr1:null,
                addr2:null,
                addr3:null
            },
            isButtonCancel: true,
            actionFlg:0,
            koumokuList:'',
            zeiKbnNm:'',
            isModalShow:false,
            listIdErr:[],
            SiteConstants: SiteConstants,
            PAGE_INSERT:'3',
            PAGE_UPDATE:'4',
            tdkNum:4,
            pageType:3,
            msgConfirm:'',
            listMessValid:[],
            mapMessValid:[],
            listReport:[],
            isButtonOK:false,
            cc212Dislay:false,
            dataCc212: {},
            cc212ReqModel:{},
            tdkIndex:null,
            site: "",
            isConfirm : false,
            isUpdateFlg: false,
            report: ""
        }
    },
    /*
    * 初期処理
    */
    mounted: function() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const id = urlParams.get('id');
        _this.registRequest.id = id;
        
        axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.REGIST + _this.$UrlConstants.DO_INIT,_this.registRequest).then(function(response) {
            _this.registInit = response.data;
            _this.registRequest = Object.assign({}, _this.registRequest, response.data.reqModel);
            _this.registRequest.pointCardNo = _this.registRequest.id;
            EventBus.$emit('title-header', _this.$router.history.current.meta.titleHeader2);
            _this.registRequest.sexKbn = 9;
            // 会員規約のセット
            var splInfo40 = _this.registInit.descriptionInfo['40'];
            if (splInfo40 != null && splInfo40.length > 0) {
                splInfo40 = splInfo40.split('\n');
                var des40 = '';
                for(var i = 0; i < splInfo40.length; i++){
                    des40 = des40.concat(splInfo40[i] + '<br>');
                }
                _this.registInit.descriptionInfo['40'] = des40;
            }
            // 説明(画面下部メッセージ)
            var splInfo46 = _this.registInit.descriptionInfo['46'];
            if (splInfo46 != null && splInfo46.length > 0) {
                splInfo46 = splInfo46.split('\n');
                var des46 = '';
                for(var ii = 0; ii < splInfo46.length; ii++){
                    des46 = des46.concat(splInfo46[ii] + '<br>');
                }
                _this.registInit.descriptionInfo['46'] = des46;
            }
            // 説明(画面上部メッセージ)
            var splInfo47 = _this.registInit.descriptionInfo['47'];
            if (splInfo47 != null && splInfo47.length > 0) {
                splInfo47 = splInfo47.split('\n');
                var des47 = '';
                for(var j = 0; j < splInfo47.length; j++){
                    des47 = des47.concat(splInfo47[j] + '<br>');
                }
                _this.registInit.descriptionInfo['47'] = des47;
            }
            // すでに登録しましたメッセージ内容
            var splInfo48 = _this.registInit.descriptionInfo['48'];
            if (splInfo48 != null && splInfo48.length > 0) {
                splInfo48 = splInfo48.split('\n');
                var des48 = '';
                for(var jj = 0; jj < splInfo48.length; jj++){
                    des48 = des48.concat(splInfo48[jj] + '<br>');
                }
                _this.registInit.descriptionInfo['48'] = des48;
            }
            // すでに登録しましたメッセージ内容
            var splInfo49 = _this.registInit.descriptionInfo['49'];
            if (splInfo49 != null && splInfo49.length > 0) {
                splInfo49 = splInfo49.split('\n');
                var des49 = '';
                for(var k = 0; k < splInfo49.length; k++){
                    des49 = des49.concat(splInfo49[k] + '<br>');
                }
                _this.registInit.descriptionInfo['49'] = des49;
            }
            // すでに登録しましたメッセージ内容
            var splInfo50 = _this.registInit.descriptionInfo['50'];
            if (splInfo50 != null && splInfo50.length > 0) {
                splInfo50 = splInfo50.split('\n');
                var des50 = '';
                for(var kk = 0; kk < splInfo50.length; kk++){
                    des50 = des50.concat(splInfo50[kk] + '<br>');
                }
                _this.registInit.descriptionInfo['50'] = des50;
            }
            // すでに登録しましたメッセージ内容
            var splInfo51 = _this.registInit.descriptionInfo['51'];
            if (splInfo51 != null && splInfo51.length > 0) {
                splInfo51 = splInfo51.split('\n');
                var des51 = '';
                for(var kkk = 0; kkk < splInfo51.length; kkk++){
                    des51 = des51.concat(splInfo51[kkk] + '<br>');
                }
                _this.registInit.descriptionInfo['51'] = des51;
            }
            _this.registRequest.dmFlg = 0;
        }).catch(function(error) {
            common.errorAPI(error);
        });

        //POPUPを閉じるイベント
        EventBus.$on('closed', function() {
            _this.isModalShow = false;
        });
    },
    /*
    * メソッド
    */
    methods: {
        /*
        * 登録ボタン押下処理
        */
        confirmDoInsert: function(){
            // 同意ラジオボタン
            if(this.registRequest.agreeFlag != 1){
                // 規約に同意いただける場合のみ会員登録することができます。
                this.msgConfirm = this.$i18n.t('regist.labels.messg1')
                this.isModalShow = true;
                this.isButtonCancel = false;
                this.actionFlg = -1;
                return;
            }
            this.msgConfirm = this.$i18n.t('regist.labels.messg2')
            this.isModalShow = true;
            this.isButtonCancel = true;
            this.actionFlg = 1;
        },
        /*
        *  登録処理
        */
        doInsert: function(){
            var _this = this;
            _this.$emit("event-loading", true);
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.REGIST_PART);

            let url = new URL(window.location.href);
            let params = url.searchParams;

            _this.registRequest.id = params.get('id');
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.REGIST + _this.$UrlConstants.DO_INSERT, _this.registRequest).then(function(response) {
                if(response.data.status == 'OK'){
                    // 登録完了メッセージ
                    _this.registInit.pageMode = response.data.response.pageMode;
                }
                _this.$emit("event-loading", !true);
            }).catch(function(error) {
                _this.$emit("event-loading", !true);
                console.log("error=",error);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.REGIST_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },

        /*
        * 更新ボタン押下処理
        */
        confirmDoUpdate: function(){
            this.msgConfirm = this.$i18n.t('regist.labels.messg3')
            this.isModalShow = true;
            this.isButtonCancel = true;
            this.actionFlg = 2;
        },
        /*
        * 入力項目を変更した場合更新ボタンをアクティブにする
        */
        change: function() {
            var _this = this;
            _this.isUpdateFlg = true;
        },
         /*
        *  POPUP表示処理 actionFlg
        * 1: 登録処理
        * 2: 更新処理
        */
        doAction: function(){
            switch (this.actionFlg) {
                case 1:
                    this.doInsert();
                    break;
                default:
                    break;
            }
            // Hide alert confirm
            this.isModalShow = false;
            this.actionFlg = 0;
            this.isButtonCancel = true;
        },
        /* 
        * Function excuteValidation 
        * analyst data message and display
        */
        displayWarning : function(errorList){
            this.listReport = [];
            // check error list
            if(errorList != null && errorList.length > 0){
                //var errorList = error.response.data.errorList;
                for(var index =0;  index < errorList.length; index ++){
                    // replace messenge
                    var messageList = errorList[index].messageList;
                    if(messageList != null && messageList.length > 0){
                        for (var mesInx = 0; mesInx < messageList.length; mesInx++){
                            var msgTemp = messageList[mesInx].message;
                            this.listReport.push(msgTemp);
                            
                        }
                    }
                }
                return this.listReport;
            }
        },
        /*
        * 住所検索処理
        */
        addrAutoInput: function(tdkIndex){
            var _this = this;
            _this.tdkIndex = tdkIndex;
            var zip = _this.registRequest.zip;
            if(_this.tdkIndex != 'kokyaku'){
                zip = _this.registRequest.tdkList[tdkIndex].tdkZip;
            }
			if(zip == '' || zip == null || zip == undefined) {
				if (_this.isModalShow != true){
					_this.isModalShow = true;
				}
				// 郵便番号は必須です。
				_this.msgConfirm =_this.$i18n.t('sh030.labels.zipCodeIsMandatory');
				_this.isButtonCancel=true;
				_this.isButtonOK=false;
				return;
			}
			var zipArr = zip.split("-");
			var zip1 = "";
			var zip2 = "";
			if (zipArr.length == 2) {
				zip1 = zipArr[0];
				zip2 = zipArr[1];
			}else{
				zip1 = zip.substr(0,3);
				zip2 = zip.substr(3);
			}
			_this.cc212ReqModel.tdkZip1 = zip1;
			_this.cc212ReqModel.tdkZip2 = zip2;
			_this.$emit("event-loading", true);
			axios.post(_this.$UrlConstants.POPUP + _this.$UrlConstants.CC212 + _this.$UrlConstants.GET_ADDR_INFO, _this.cc212ReqModel).then(function(response) {
				if (response.data.allAddr == 'juufuku'){
					_this.dataCc212.propTdkZip1 = zip1;
					_this.dataCc212.propTdkZip2 = zip2;
					_this.cc212Dislay = true;
				}
				else {
					_this.setAddr(response.data.allAddr ,response.data.kenCd,response.data.kenNm, zip1 ,zip2,tdkIndex);
				}
				_this.$emit("event-loading", !true);
			}).catch(function(error) {
				_this.$emit("event-loading", !true);
				common.errorAPI(error);
			});
		},
		// 住所検索Ajaxの戻り
		// パラメータの_addrに「住所,町名番地,建物名・部屋番号」の形で戻ってくる(30文字ずつ)
		setAddr: function (addr, kenCd , kenNm, zip1 , zip2){
            var _this = this;
            var sp = new Array("","","");
			if (addr) {
                sp = addr.split(",");
                var displayAddr = sp[0]==null?'':sp[0] ;
                displayAddr += sp[1]==null?'':sp[1];
                displayAddr += sp[2]==null?'':sp[2];

                if(_this.tdkIndex == 'kokyaku'){
                    //都道府県のプルダウンを使用しない場合
                    _this.registRequest.addr1 = kenNm + displayAddr;
                    _this.registRequest.kenCd = kenCd;
                    _this.registRequest.zip = zip1+ "-" +zip2;
                } else{
                    //都道府県のプルダウンを使用しない場合
                    if(_this.registInit.kenPulldownDispFlg == 0){
                        _this.registRequest.tdkList[_this.tdkIndex].tdkAddr1 = kenNm + displayAddr;
                    }else{
                        _this.registRequest.tdkList[_this.tdkIndex].tdkAddr1 = displayAddr;
                    }
                    _this.registRequest.tdkList[_this.tdkIndex].tdkKenCd = kenCd;
                    _this.registRequest.tdkList[_this.tdkIndex].tdkZip = zip1+ "-" +zip2;
                }
				_this.$forceUpdate();
			}else{
				if (_this.isModalShow != true){
					_this.isModalShow = true;
				}
				// 郵便番号が存在しません
				_this.msgConfirm =_this.$i18n.t('sh030.labels.zipCodeDoesNotExist');
				_this.registRequest.zip= '';
				_this.isButtonCancel=true;
				_this.isButtonOK=false;
			}
		},
    },
    beforeDestroy() {
        EventBus.$off('closed');
        EventBus.$off('is-loading');
    }
}
</script>